module.exports = __webpack_public_path__ + "img/14.c04e4f80.jpg";